import { create } from 'zustand';
import type { AuthUser } from '@family-wishlist/shared';
import { api, ApiError } from '@/lib/api';

interface AuthState {
  user: AuthUser | null;
  status: 'idle' | 'loading' | 'ready';
  init: () => Promise<void>;
  login: (username: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  refresh: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: 'idle',
  init: async () => {
    set({ status: 'loading' });
    try {
      const user = await api.get<AuthUser>('/api/auth/me');
      set({ user, status: 'ready' });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        set({ user: null, status: 'ready' });
        return;
      }
      set({ user: null, status: 'ready' });
    }
  },
  login: async (username, password) => {
    const user = await api.post<AuthUser>('/api/auth/login', { username, password });
    set({ user });
  },
  logout: async () => {
    try {
      await api.post('/api/auth/logout');
    } finally {
      set({ user: null });
    }
  },
  refresh: async () => {
    try {
      const user = await api.get<AuthUser>('/api/auth/me');
      set({ user });
    } catch {
      set({ user: null });
    }
  },
}));
